"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _IMService = require("./im/IMService");

var _IMService2 = _interopRequireDefault(_IMService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    IMService: _IMService2.default
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ciim_sdk@3.0.8@ciim_sdk/dist/index.js
// module id = zBIS
// module chunks = 0